var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "stepOut" }, [
    _c(
      "div",
      { staticClass: "stepItem" },
      [
        _c("el-image", {
          staticClass: "stepItem_img",
          attrs: {
            src:
              _vm.stepInfo.status >= 1
                ? "https://small.ygcha.com.cn/icon_shenqing _activate.png"
                : "https://small.ygcha.com.cn/icon_shenqing _default.png",
            alt: "",
          },
        }),
        _c("p", { class: _vm.stepInfo.status >= 1 ? "blue" : "gray" }, [
          _vm._v("售后申请"),
        ]),
        _c("p", { staticClass: "time" }, [
          _vm._v(_vm._s(_vm.stepInfo.applyTime)),
        ]),
        _vm.stepInfo.status == 7
          ? _c("div", { staticClass: "stepItem_xian lineAction1" })
          : _c("div", { staticClass: "stepItem_xian lineAction" }),
        _vm.stepInfo.status == 7
          ? _c("div", { staticClass: "applyC" }, [_vm._v("申请已取消")])
          : _vm._e(),
        _vm.stepInfo.status == 7
          ? _c("div", { staticClass: "dots" })
          : _vm._e(),
        _vm.stepInfo.status == 7
          ? _c("div", { staticClass: "dots1" })
          : _vm._e(),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "stepItem shenheStatus" },
      [
        _c("el-image", {
          staticClass: "stepItem_img",
          attrs: {
            src:
              _vm.stepInfo.status !== 1 && _vm.stepInfo.status !== 7
                ? "https://small.ygcha.com.cn/icon_shenhe _activate.png"
                : "https://small.ygcha.com.cn/icon_shenhe _default.png",
            alt: "",
          },
        }),
        _c(
          "p",
          {
            class:
              _vm.stepInfo.status !== 1 && _vm.stepInfo.status !== 7
                ? "blue"
                : "gray",
          },
          [_vm._v(" 提交审核 ")]
        ),
        _c("p", { staticClass: "time" }, [
          _vm._v(_vm._s(_vm.stepInfo.auditTime)),
        ]),
        _vm.stepInfo.status == 2
          ? _c("div", { staticClass: "stepItem_xian lineAction1" })
          : _c("div", {
              class:
                _vm.stepInfo.status !== 1 && _vm.stepInfo.status !== 7
                  ? "stepItem_xian lineAction"
                  : "stepItem_xian",
            }),
        _vm.stepInfo.status == 2
          ? _c("div", { staticClass: "applyC" }, [_vm._v("申请已驳回")])
          : _vm._e(),
        _vm.stepInfo.status == 2
          ? _c("div", { staticClass: "dots" })
          : _vm._e(),
        _vm.stepInfo.status == 2
          ? _c("div", { staticClass: "dots1" })
          : _vm._e(),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "stepItem wuliubtn" },
      [
        _c("el-image", {
          staticClass: "stepItem_img",
          attrs: {
            src:
              _vm.stepInfo.status == 4 || _vm.stepInfo.status == 8
                ? "https://small.ygcha.com.cn/icon_jihui _activate.png"
                : "https://small.ygcha.com.cn/icon_jihui _default.png",
            alt: "",
          },
        }),
        _c(
          "p",
          {
            class:
              _vm.stepInfo.status == 4 || _vm.stepInfo.status == 8
                ? "blue"
                : "gray",
          },
          [_vm._v(" 买家寄回 ")]
        ),
        _c("p", { staticClass: "time" }, [
          _vm._v(_vm._s(_vm.stepInfo.sendBackTime)),
        ]),
        _c("div", {
          class:
            _vm.stepInfo.status == 4 || _vm.stepInfo.status == 8
              ? "stepItem_xian lineAction"
              : "stepItem_xian",
        }),
        _c(
          "div",
          { staticClass: "btn" },
          [
            _vm.stepInfo.status == 8 || _vm.stepInfo.status == 4
              ? _c(
                  "el-button",
                  {
                    attrs: { size: "mini", type: "primary", plain: "" },
                    on: {
                      click: function ($event) {
                        return _vm.examine(1)
                      },
                    },
                  },
                  [_vm._v("查看物流")]
                )
              : _vm._e(),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "stepItem" },
      [
        _c("el-image", {
          staticClass: "stepItem_img",
          attrs: {
            src:
              _vm.stepInfo.status == 8
                ? "http://small.jianchiyaoye.com/icon_wancheng_activate.png"
                : "http://small.jianchiyaoye.com/icon_wancheng_default.png",
            alt: "",
          },
        }),
        _c("p", { class: _vm.stepInfo.status == 8 ? "blue" : "gray" }, [
          _vm._v("售后完成"),
        ]),
        _c("p", { staticClass: "time" }, [
          _vm._v(_vm._s(_vm.stepInfo.completeTime)),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }